import { useId } from "react"

import IconProps from "./icons.types"

export default function LumenLogo({
  className,
  style,
  width,
  height,
  dark = false,
}: IconProps) {
  // Generate a randomized string to append to ids present in this file (clipPaths and linearGradients)
  // This avoids gradient fill issues when a hidden version of the logo also appears on the page
  const id = useId()
  const letterFill = dark ? "#ffffff" : "#000000"

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1921 475.15"
      className={className}
      style={style}
      width={width}
      height={height}
      role="img"
    >
      <title>Return to your home page</title>
      <defs>
        <clipPath id={`lumen-logo-clip-path-${id}`}>
          <rect width="1921" height="475.15" fill="none" />
        </clipPath>
        <clipPath id={`lumen-logo-clip-path-2-${id}`}>
          <path
            d="M158.67,27.5a144.9,144.9,0,0,0,0,288.87c3.88.31,7.75.49,11.68.49a144.5,144.5,0,0,0,53.53-10.23A171.56,171.56,0,0,1,158.67,172v-.09A171.55,171.55,0,0,1,223.88,37.24,144.51,144.51,0,0,0,170.35,27c-3.93,0-7.8.18-11.68.5"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id={`linear-gradient-${id}`}
          x1="856.66"
          y1="-136.45"
          x2="857.66"
          y2="-136.45"
          gradientTransform="matrix(198.49, 0, 0, -198.49, -170013.5, -26911.2)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#c2f4e3" />
          <stop offset="1" stopColor="#b6dad5" />
        </linearGradient>
        <clipPath id={`lumen-logo-clip-path-3-${id}`}>
          <path
            d="M412.17,52.16a146.63,146.63,0,0,0-20.89,17.3,145,145,0,1,0,20.88-17.29"
            fill="none"
          />
        </clipPath>
        <linearGradient
          id={`linear-gradient-2-${id}`}
          x1="858.28"
          y1="-137.59"
          x2="859.28"
          y2="-137.59"
          gradientTransform="translate(-271585.67 43762.15) scale(316.82)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#36daa3" />
          <stop offset="1" stopColor="#8e70d3" />
        </linearGradient>
      </defs>
      <polygon
        fill={letterFill}
        points="707.1 374.41 755.98 374.41 755.98 382.5 716.38 382.5 716.38 404.71 751.93 404.71 751.93 412.79 716.38 412.79 716.38 437.54 756.98 437.54 756.98 445.61 707.1 445.61 707.1 374.41"
      />
      <polygon
        fill={letterFill}
        points="811.98 374.41 825.21 374.41 858.94 433.5 859.85 433.5 859.85 374.41 869.04 374.41 869.04 445.61 855.91 445.61 822.18 386.54 821.17 386.54 821.17 445.61 811.98 445.61 811.98 374.41"
      />
      <polygon
        fill={letterFill}
        points="928.58 374.41 977.46 374.41 977.46 382.5 937.87 382.5 937.87 404.71 973.41 404.71 973.41 412.79 937.87 412.79 937.87 437.54 978.47 437.54 978.47 445.61 928.58 445.61 928.58 374.41"
      />
      <g clipPath="url(#lumen-logo-clip-path)">
        <path
          fill={letterFill}
          d="M1033.46,374.42h31c15.45,0,25.65,8.48,25.65,21.62,0,12.1-9.5,20.59-22.72,21.2h-1.21L1092,445.61h-11.62l-24.64-27.87h-13.12v27.87h-9.2Zm31,35.24c10.19,0,16.45-5.24,16.45-13.62s-6.26-13.54-16.45-13.54h-21.81v27.16Z"
        />
        <path
          fill={letterFill}
          d="M1141.07,410c0-22.1,16.06-38.06,38.38-38.06,15,0,28.48,8.67,32.42,20.59l-8.39,2.84c-3-8.9-13-15.36-24-15.36-17.07,0-29.19,12.42-29.19,30,0,17.38,12.23,30.11,29.19,30.11,15.35,0,27.47-11,27.87-25.36L1172,414.6v-8.17h44.63c1.52,24.24-14,41.72-37.16,41.72-22.32,0-38.38-16.07-38.38-38.19"
        />
        <polygon
          fill={letterFill}
          points="1290.99 419.56 1265.24 374.41 1274.94 374.41 1295.13 410.77 1296.15 410.77 1315.94 374.41 1325.83 374.41 1300.29 419.56 1300.29 445.61 1290.99 445.61 1290.99 419.56"
        />
        <polygon
          fill={letterFill}
          points="750.38 63.89 707.1 63.89 707.1 280.02 871.07 280.02 871.07 238.82 750.38 238.82 750.38 63.89"
        />
        <path
          fill={letterFill}
          d="M1040,174.31c0,32.88-20.81,68.68-64.1,68.68-30.37,0-50.77-18.33-50.77-69.09V69.43H881.87V193c0,58.68,27.88,91.14,77.41,91.14,34.12,0,61.18-16.64,81.15-37.86l2.08,33.7h40.79V69.43H1040Z"
        />
        <path
          fill={letterFill}
          d="M1369.62,65.27c-33.72,0-59.52,19.56-78.66,44.12-10-27-31.21-44.12-62.85-44.12-30.38,0-54.52,15.82-72.83,37l-2.08-32.88h-40.78V280h43.27V184.71c2.09-44.11,22.9-78.23,56.19-78.23,27.47,0,42,22.47,42,56.17V280h43.28V184.71c2.08-44.11,22.89-78.23,56.18-78.23,27.06,0,42,22.47,42,56.17V280h43.28V148.1c0-48.7-24.14-82.83-69.08-82.83"
        />
        <path
          fill={letterFill}
          d="M1566.43,65.27c-63.27,0-105.29,49.53-105.29,108.22,0,62.83,44.52,110.7,108.62,110.7,56.6,0,89.48-38.3,96.56-67.43l-37.88-4.16c-8.74,16.22-27.88,32.88-58.27,32.88-40.37,0-64.51-25-65.75-57.43h167.3V177.22c0-59.92-40.37-111.95-105.29-111.95m-62,92.4c1.66-29.56,26.63-53.69,62-53.69,36.62,0,59.93,25.39,61.6,53.69Z"
        />
        <path
          fill={letterFill}
          d="M1818.2,65.27c-34.13,0-61.18,16.65-81.16,37.87l-2-33.71h-40.78V280h43.28V170.15c2.07-31.22,22.89-63.67,64.08-63.67,30.39,0,50.77,18.3,50.77,69.08V280h43.3V156.41c0-58.68-27.9-91.14-77.41-91.14"
        />
      </g>
      <g clipPath={`url(#lumen-logo-clip-path-2-${id})`}>
        <rect
          x="25.39"
          y="27"
          width="198.49"
          height="289.86"
          fill={`url(#linear-gradient-${id})`}
        />
      </g>
      <g clipPath={`url(#lumen-logo-clip-path-3-${id})`}>
        <rect
          x="348.83"
          y="27.01"
          width="289.9"
          height="289.9"
          fill={`url(#linear-gradient-2-${id})`}
        />
      </g>
      <g clipPath="url(#lumen-logo-clip-path)">
        <path
          d="M386.06,305.86a145.52,145.52,0,0,1-55.52,11.05c-2.88,0-5.77-.18-8.65-.36a144.87,144.87,0,0,1,0-289.23c2.88-.18,5.77-.32,8.65-.32a144,144,0,0,1,55.57,11,171.54,171.54,0,0,0-64.22,133.81v.1a171.62,171.62,0,0,0,64.17,133.9"
          fill="#5fd6ab"
        />
      </g>
    </svg>
  )
}
